module.exports = __webpack_public_path__ + "static/media/emailWhite.2f9262b2.svg";